
export const BranchesDashboardPermissions = {
    AccountsDashboard: {
    permissionsId:'ce0d07f2-f7de-4fa8-1cd3-08dabfc53c80',
    permissionsName:'Branches Dashboard',
    componentsId:null,
    components:null
  }
  } ;
  